import script from "./AddTeacher.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTeacher.vue?vue&type=script&setup=true&lang=js"

import "./AddTeacher.vue?vue&type=style&index=0&id=6af1ffc6&lang=css"

const __exports__ = script;

export default __exports__